import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, Receipt, User } from 'lucide-react';
import { useT } from '../lib/i18n';

export function BottomNav() {
  const { t } = useT();
  const items = [
    { to: '/', icon: Home, label: t('nav.dashboard'), testid: 'nav-dashboard' },
    { to: '/submissions', icon: FileText, label: t('nav.submissions'), testid: 'nav-submissions' },
    { to: '/invoices', icon: Receipt, label: t('nav.invoices'), testid: 'nav-invoices' },
    { to: '/profile', icon: User, label: t('nav.profile'), testid: 'nav-profile' },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t-2 border-gray-100 pb-safe"
    >
      <div className="max-w-2xl mx-auto flex justify-around items-stretch h-[72px]">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === '/'}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 gap-1 text-[11px] font-bold uppercase tracking-wider transition-colors ${
                isActive ? 'text-[#7A1F2B]' : 'text-gray-400'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all ${
                    isActive ? 'bg-[#7A1F2B] text-white' : ''
                  }`}
                >
                  <it.icon size={20} strokeWidth={2.2} />
                </div>
                <span>{it.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
